import React, { useEffect } from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import { briefRuntimeStore } from '@fiverr-private/variations_display';
import { UserAgentContext } from '../../../shared/components/UserAgentContext';
import monitor from '../../../service/bigquery';
import { useOnceBeforeRender } from '../../../shared/hooks';
import { RolloutsContext } from '../../../shared/components/RolloutsContext';
import type { UserAgentData } from '../../../shared/lib/getUserAgent';
import type { TrackingData } from '../../../shared/lib/getTrackingData';
import Listings from '../../components/Listing';

interface ClientBuyerPageProps {
  currentUser: any;
  briefId: string;
  appData: any;
  userAgent: UserAgentData;
  requireRegistration: boolean;
  rollouts: Record<string, boolean>;
  tracking: TrackingData;
  mixpanel: {
    fromBoost: 0 | 1;
  };
  totalPages: number;
}

export default function ClientBuyerPage({
  currentUser,
  briefId,
  appData,
  userAgent,
  requireRegistration,
  rollouts,
  tracking,
  mixpanel,
  totalPages,
}: ClientBuyerPageProps) {
  useOnceBeforeRender(() => {
    monitor.initialize(tracking);

    makersExperience.buyer.setData({
      fromBoost: mixpanel.fromBoost,
    });
  });

  useEffect(() => {
    briefRuntimeStore.clearBrief();
  }, []);

  return (
    <RolloutsContext.Provider value={rollouts}>
      <UserAgentContext.Provider value={userAgent}>
        <Listings
          currentUser={currentUser}
          briefId={briefId}
          appData={appData}
          requireRegistration={requireRegistration}
          totalPages={totalPages}
          tracking={tracking}
        />
      </UserAgentContext.Provider>
    </RolloutsContext.Provider>
  );
}
